
const Support = () => import(/* webpackChunkName: "support" */ '@/pages/support/Index');
const Donate = () => import(/* webpackChunkName: "support" */ '@/pages/support/Donate');
const QrcodeIndex = () => import(/* webpackChunkName: "support" */ '@/pages/support/QrcodeIndex');
const QrcodeView = () => import(/* webpackChunkName: "support" */ '@/pages/support/QrcodeView');
//const Status = () => import(/* webpackChunkName: "support" */ '@/pages/support/Status');

export default function (router) {
    // 路由配置
    router.addRoutes([
        {
            path: '/support',
            component: Support,
            meta: {
                title: '支持我们',
                dialog: false,
            }
        },
        {
            path: '/support/qrcode',
            component: QrcodeIndex,
            meta: {
                title: '二维码列表',
                dialog: true,
            }
        },
        {
            path: '/support/qrcode/:id',
            component: QrcodeView,
            meta: {
                title: '二维码',
                dialog: false,
            }
        },
        {
            path: '/support/donate',
            component: Donate,
            meta: {
                title: '小额捐助',
                dialog: false
            }
        },
        // {
        //     path: '/support/status',
        //     component: Status,
        //     meta: {
        //         title: '历程',
        //         dialog: '#e9f0f5',
        //     }
        // }
    ]);
}